import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChangePasswordComponent } from './page/change-password/change-password.component';
import { ForgotPasswordChallengeComponent } from './page/forgot-password-challenge/forgot-password-challenge.component';
import { ForgotPasswordComponent } from './page/forgot-password/forgot-password.component';
import { ForgotPasswordMfaComponent } from './page/forgot-password-mfa/forgot-password-mfa.component';
import { ForgotPasswordVerifyComponent } from './page/forgot-password-verify/forgot-password-verify.component';

const routes: Routes = [
  {
    path: '',
    component: ForgotPasswordComponent
  },
  {
    path: 'verify',
    component: ForgotPasswordVerifyComponent
  },
  {
    path: 'mfa-verify',
    component: ForgotPasswordMfaComponent
  },
  {
    path: 'challenge-verify',
    component: ForgotPasswordChallengeComponent
  },
  {
    path:'change-password',
    component: ChangePasswordComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForgotPasswordRoutingModule { }
